import { Avatar, AvatarGroup } from '@mui/material';
export const AvatarGroupModule = () => {
  return (
    <AvatarGroup max={6}>
      <Avatar
        alt="Tabitha Stevenson"
        src={process.env.PUBLIC_URL + `/static/images/avatars/1.png`}
      />
      <Avatar
        alt="Dean"
        src={process.env.PUBLIC_URL + `/static/images/avatars/2.png`}
      />
      <Avatar
        alt="Kate Scott"
        src={process.env.PUBLIC_URL + `/static/images/avatars/3.png`}
      />
      <Avatar
        alt="Alyssa Parr"
        src={process.env.PUBLIC_URL + `/static/images/avatars/4.png`}
      />
      <Avatar
        alt="Jenée Arthur"
        src={process.env.PUBLIC_URL + `/static/images/avatars/5.png`}
      />
      <Avatar
        alt="Jenée Arthur"
        src={process.env.PUBLIC_URL + `/static/images/avatars/6.png`}
      />
    </AvatarGroup>
  );
};
